// extracted by mini-css-extract-plugin
export default {"container":"Yo-z","brandName":"Zo-z","productName":"_o-z","productNamePdpEnhancements":"ap-z","breakLongProductName":"bp-z"};